import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';

import type { t_status, TQuery, TEventCapture } from'../../../pip/library/pi-ess/src/types/event_type/pi-ess/src/types/event_type.js';
import ess from'../../../pip/library/pi-ess/pi-ess.js';
import tt from'../../../pip/library/pi-tt/pi-tt.js';

export interface ILoggingModuleConfiguration extends IModuleConfiguration {
  /**
   * an assignment is a binding or pipe
   * this is used to power AIP, all data flows through assignments
   */
  assignments: t_status[];
  /**
   * show the transpiler errors from it's codex
   */
  transpiler: t_status[];
  /**
   * log system-wide ess messages (choose a status)
   */
  system: t_status[];
  /**
   * ess events for custom logging
   */
  custom: TEventCapture[];
}

export class LoggingModule extends ModuleConfiguration {
  configuration: ILoggingModuleConfiguration;

  /**
   *
   * @param configuration
   */
  initialize(configuration: ILoggingModuleConfiguration) {
    return new Promise((resolve) => {
      const conf = (this.configuration = this.__defaultConfiguration(configuration));

      if (!tt.isEmpty(conf.assignments)) {
        this.__logAssignments(conf.assignments);
      }
      if (!tt.isEmpty(conf.transpiler)) {
        this.__logTranspiler(conf.transpiler);
      }
      if (!tt.isEmpty(conf.system)) {
        this.__logSystem(conf.system);
      }
      if (!tt.isEmpty(conf.custom)) {
        this.__logCustom(conf.custom);
      }

      resolve(conf);
    });
  }

  private __defaultConfiguration(configuration: ILoggingModuleConfiguration) {
    return tt.mergeWith(
      'clobber',
      {
        assignments: [],
        transpiler: [],
        custom: [],
        system: []
      },
      configuration
    ) as ILoggingModuleConfiguration;
  }

  private __logAssignments(statuses: t_status[]) {
    ess.on(
      {
        site: ['hi-binding', 'hi-pipe'],
        status: statuses
      } as TQuery,
      ess.reporters.console
    );
  }

  private __logTranspiler(statuses: t_status[]) {
    ess.on(
      {
        status: statuses,
        codex: 'codex',
        site: 'hil'
      } as TQuery,
      ess.reporters.console
    );
  }

  private __logSystem(statuses: t_status[]) {
    /**
     * filter out all assignment and codex events because of other logs
     */
    ess.on(
      {
        site: ['!hi-binding', '!hi-pipe'],
        codex: '!codex',
        status: statuses
      } as TQuery,
      ess.reporters.console
    );
  }

  private __logCustom(custom: TEventCapture[]) {
    tt.each((event) => {
      ess.on(event, ess.reporters.console);
    }, custom);
  }
}
